import PropTypes from 'prop-types';
import SideNav from '../../molecules/SideNav/SideNav';
import styles from './MainLayout.module.css';
import React from 'react';
import { brandConfig } from '../../../brands';
/**
 * Main layout component that wraps around the content of the application.
 *
 * @param {Object} props - The component props.
 * @param {string} props.pageName - The name of the current page.
 * @param {React.ReactNode} props.children - The content to be rendered inside the main layout.
 * @returns {JSX.Element} The main layout with navigation and content.
 */

const currentYear = new Date().getFullYear();

export default function MainLayout({
  // pageName = '',
  children,
}) {
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  const otherChildren = childrenArray.slice(1);
  const hasToolbar = otherChildren.length > 0;

  return (
    <div className={styles.shell}>
      <div className={styles.sideNav}>
        <SideNav />
      </div>

      <div className={styles.page}>
        <div
          className={`${styles.wrapper} ${hasToolbar ? styles.wrapperWithToolbar : styles.wrapperNoToolbar}`}
        >
          {hasToolbar && (
            <header className={styles.topBar} role="banner">
              <div className="mx-auto my-auto h-full max-w-[1600px]">
                {firstChild}
              </div>
            </header>
          )}

          <main className={`${styles.main} main-content-container`} role="main">
            <div className={styles.mainInner}>
              <div className={styles.mainChildren}>
                {hasToolbar ? otherChildren : firstChild}
              </div>
            </div>
          </main>

          <footer className={styles.footer} role="contentinfo">
            {brandConfig.footer.leftBrand && (
              <span className={styles[brandConfig.footer.leftBrand.className]}>
                {brandConfig.footer.leftBrand.text}
              </span>
            )}{' '}
            {brandConfig.footer.release && (
              <span className={styles[brandConfig.footer.release.className]}>
                {brandConfig.footer.release.text}
                {brandConfig.footer.release.showYear && ` ${currentYear}`}
              </span>
            )}{' '}
            {brandConfig.footer.poweredBy && (
              <span className={styles[brandConfig.footer.poweredBy.className]}>
                {brandConfig.footer.poweredBy.text}
              </span>
            )}{' '}
            {brandConfig.footer.rightBrand && (
              <span className={styles[brandConfig.footer.rightBrand.className]}>
                {brandConfig.footer.rightBrand.text}
              </span>
            )}
          </footer>
        </div>
      </div>
    </div>
  );
}

MainLayout.propTypes = {
  pageName: PropTypes.string,
  children: PropTypes.node,
};

MainLayout.displayName = 'MainLayout';
